import React from 'react'

type Props = {}

const Loader = (props: Props) => {
  return (
    <div className="d-flex justify-content-center" style={{
        position: "absolute",
        left: 0,
        top: 0,
        zIndex: 100000,
        background: "lightgray",
        width: "100%",
        height: "100%",
        opacity: 0.6,
    }}>
        <div className="spinner-border" role="status" style={{
            alignSelf: "center",
            color: "blue",
            opacity: 1,
        }}>
        </div>
    </div>
  )
}

export default Loader